import React, { useState, useEffect } from "react";

import secureLocalStorage from "react-secure-storage";

const CheckInStep1 = ({ handleNext }) => {
  const [fadeOut, setFadeOut] = useState(false);

  const [patientName, setPatientName] = useState(null);

  useEffect(() => {
    const patientInfo = secureLocalStorage.getItem("patient_info");
    if (patientInfo) {
      setPatientName(patientInfo?.patient_name)
    }
  }, []);
  const handleNextWithFadeOut = () => {
    
    setFadeOut(true);
    setTimeout(() => {
      handleNext();
    }, 500);
  };

  return (
    <div
      className={`modal-container animated-onboarding onboarding-step1 ${
        fadeOut ? "fade-out-left" : ""
      }`}
    >
      <div className="modal-container-title heading fade1 typewriter-container">
        <div className="tag-container">
          <span className="tag">Recovery Update</span>
        </div>
        <h3>
          Hi {patientName ? patientName : "There"}, your progress <br />
          deserves attention!
        </h3>
      </div>
      <div className="modal-contect-title fade-fast flex jc-center">
        <p style={{ maxWidth: "375px" }}>
          This takes <b>less than a minute</b> — your answers help us
          personalize your journey and give you feedback that actually fits your
          progress. 🙌
        </p>
      </div>

      <>
        <div className="nav-container fade-fast">
          <button className="btn-next next-btn" onClick={handleNextWithFadeOut}>
            Let's Go!
          </button>
        </div>
        <div className="dot-container fade-fast">
          <div className="dot-checked"></div>
          <div className="dot-unchecked"></div>
          <div className="dot-unchecked"></div>
          <div className="dot-unchecked"></div>
        </div>
      </>
    </div>
  );
};

export default CheckInStep1;
